<app-sidenav page="shop"  menuType>

<div
  (scroll)="clearScrollFlag()"
  class="form-list" [ngClass]="{tablet: menuType==2}" *ngIf="products$ | async as products">

  <mat-accordion
    [multi]="true">

    <mat-expansion-panel
    *ngFor="let category of products | GroupByCategory"
      (afterExpand)="expanded(category.id, 1)"
      (afterCollapse)="expanded(category.id, 0)"
      [expanded]="!isCollapsed(category.id)"
      class="product-page"
      >
      <mat-expansion-panel-header
        class="product-category">
        <mat-panel-title>
          {{ category.label }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-card
        *ngFor="let product of category.items"
        [class]="'card-bottom'">
        <div
          [id]="product.getId()"
          (click)="open(product.getId())"  >
          <mat-card-header>
            <div mat-card-avatar class="item-img"
              [ngStyle]="{'background-image': 'url(' + product.getImagesList()[0] + ')'}" >
            </div>
            <mat-card-title> {{ product.getName() }}</mat-card-title>
            <mat-card-subtitle>{{ product.getShortdescription() }}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-footer class="product-footer flex flex-wrap items-center justify-between gap-2 p-3 border-t border-gray-100">
          
          <div class="product-footer-rows">
          <div class="product-row-1">
                <span>{{ 'product.size_label' | translate }}:</span>
              <!-- Price Section (Right / Fixed shrink) -->
              <div class="price-container shrink-0 text-right ml-auto">
                <span class="price-text text-base font-semibold text-gray-900 whitespace-nowrap">
                  {{ (product?.getPrice() | number:'1.2-2')?.replace(',',' ')?.replace('.',',') }} {{ currencysymbol }}
                </span>
              </div>
              

          </div>  
          <!-- Quantity Section (Left / Flexible) -->
          <div class="qty-section flex-1 min-w-0">
            <ng-container *ngIf="getColorQuantities(product).length > 0; else fallbackQty">
              <div class="color-qty-list flex flex-wrap gap-1.5">
                <span 
                  *ngFor="let item of getColorQuantities(product)"
                  class="color-badge text-xs px-2 py-0.5 rounded border flex items-center gap-1"
                  [ngClass]="item.qty > 0 ? 'bg-gray-50 text-gray-700 border-gray-200' : 'bg-rose-50 text-rose-600 border-rose-100 opacity-60'">
                  <span class="size-badge text-xs px-1.5 py-0.5 rounded" [ngStyle]="{'background-color': item.bgcolor, 'color': item.fgcolor}">
                    {{ item.label }}
                  </span>
                  <strong *ngIf="product?.getQtyn() && item.qty > 0 else fallbackQty">{{ item.qty }}</strong>
                </span>
              </div>
            </ng-container>

            <ng-template #fallbackQty>
              <div *ngIf="product?.getQtyn()">
                <span 
                  class="qty-badge text-xs font-medium px-2.5 py-1 rounded-full inline-block"
                  [ngClass]="getTotalQty(product) > 0 ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-700'">
                  <ng-container *ngIf="getTotalQty(product) > 0; else outOfStock">
                    {{ 'product.qty' | translate }}: <strong>{{ getTotalQty(product) }}</strong>
                  </ng-container>                  
                </span>
              </div>
            </ng-template>
            <ng-template #outOfStock>
                    {{ 'product.qty0' | translate }}
              </ng-template>
          </div>
          </div>

        </mat-card-footer>
        </div>
      </mat-card>

    </mat-expansion-panel>

  </mat-accordion>
</div>

<ng-template #loading>
  <div class="form-wait-bg"></div>
  <div class="form-wait">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

</app-sidenav>